"use client";

import styles from "./styles.module.css";
import Button from "@components/atoms/Button";
import Description from "@components/atoms/Description";
import H2 from "@components/atoms/H2";
import SwiperImage from "@components/atoms/Swiper";
import { useTranslations } from "next-intl";
import Image from "next/image";
import React from "react";

export default function SolutionsSubPagesTemplate1({
  sections,
  translation,
  hasSwiper,
}: {
  sections: any;
  translation: string;
  hasSwiper?: boolean;
}) {
  const t = useTranslations(translation);
  const handleReadMore = (link: string) => {
    window.open(link, "_self");
  };
  return (
    <section className=" flex w-full z-[40] gap-16 md:gap-0 xs:px-4 md:px-10  flex-col items-center">
      {sections.map((item: any, key: number) => {
        return (
          <div
            key={key}
            className={`
          justify-between
          relative 
          gap-3 md:gap-10
          w-full  
          ${key % 2 ? "md:border-r-4" : "md:border-r-0"} 
          ${key % 2 ? "md:border-l-0" : "md:border-l-4"} 
          border-[#361174]
          p-0 md:p-10 
          flex 
          ${
          key === 0
            ? "border-t-0"
            : key % 2
              ? "md:border-t-0"
              : "md:border-t-4"
          }
          ${
          key === sections.length - 1
            ? "border-b-0"
            : key % 2
              ? "md:border-b-0"
              : "md:border-b-4"
          }
          ${
          key % 2
            ? "flex flex-col-reverse md:flex-row-reverse"
            : "flex flex-col-reverse  md:flex-row"
          }
        `}
          >
            <div
              className={`${styles.light} ${
                key % 2 ? "-right-[16px]" : "-left-[16px]"
              }`}
            ></div>
            <div
              className={
                key < sections.length - 1 && !(key % 2)
                  ? styles["right-light"]
                  : ""
              }
            ></div>
            <div
              className={
                key < sections.length - 1 && key % 2 ? styles["left-light"] : ""
              }
            ></div>
            <div className="w-full flex flex-col  items-center md:items-end md:w-2/3 max-w-[800px]">
              <H2
                translation={`${translation}.${key}`}
                text={"title"}
                style={`w-full !text-[2.1rem] text-4xl md:text-5xl px-4 ${
                  key % 2
                    ? "text-center md:!text-right"
                    : "text-center md:!text-left"
                }`}
              />
              <Description
                style={`xs:!text-[1.1rem] md:!text-[1.2rem] px-4 ${
                  key % 2
                    ? "text-center md:!text-right"
                    : "text-center md:!text-left"
                }`}
              >
                {t(`${key}.description`)}
              </Description>
              {item.button && (
                <div
                  className={`w-fit flex mt-5 ${
                    key % 2
                      ? "self-center md:self-end"
                      : "self-center md:self-start"
                  }`}
                >
                  <Button
                    translation={`${translation}.${key}`}
                    text={"button"}
                    onClickEvent={() => handleReadMore(t(`${key}.link`))}
                  />
                </div>
              )}
            </div>
            <div className={styles.container__swiper}>
              {hasSwiper ? (
                <SwiperImage
                  slides={["logo-labs-white.webp", "logo-labs-white.webp"]}
                />
              ) : (
                <Image
                  priority={true}
                  width={250}
                  height={250}
                  src={item.img ? item.img : "/logo-labs-white.webp"}
                  alt={item.alt}
                  title={item.imageTitle}
                  className="object-contain self-center xs:max-h-[200px] md:max-h-[240px]"
                />
              )}
            </div>
          </div>
        );
      })}
    </section>
  );
}
